// extracted by mini-css-extract-plugin
module.exports = {"comp":"PowerWorld_comp__g_Kst"};